import React,{useState,useEffect} from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import BankHeader from "./BankHeader";
import BankTable from "./BankTable";
import { useLocation } from "react-router-dom";
import { fetchFormData } from "../../utils/options";

const BankList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  const [permission, setPermission] = useState(null);

  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const M_id = queryParams.get("id");

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", M_id);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;

        setPermission(perm);

      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [M_id]);
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <BankHeader permission={permission}/>
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <BankTable permission={permission}/>
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default BankList;
